const Detail = ({ selectedOption = {}, renderDetail, onBack, isLandscape, navigation }) =>
    selectedOption.renderDetail
        ? selectedOption.renderDetail({ selectedOption, onBack, isLandscape, navigation })
        : renderDetail({ selectedOption, onBack, isLandscape, navigation });

export default Detail;
